import { Box, Table, TableBody, TableContainer } from '@mui/material';
import React from 'react';
import { LoadingRow } from '../../DashboardOrder/components/GenerateRow';
import { TemplateRow } from './TemplateRow.jsx';
import {
  StyledTableCell,
  StyledTableHead,
  StyledTableRow,
} from '../../../../helpers/themes/TableTheme.jsx';

export const TableComponent = ({
  templates,
  loading,
  setIsView,
  setIsEdit,
  setIsDelete,
  setSelectedTemplate,
}) => {
  const head = [
    'Référence',
    'Titre',
    'Store',
    'Langue',
    'Service',
    'Type de client',
    'Status',
    'Auteur',
    'Date de création',
    'Dernière modification',
  ];

  return (
    <>
      <Box sx={{ paddingTop: 3 }}>
        <TableContainer sx={{ borderRadius: 0, padding: '2%' }}>
          <Table>
            <StyledTableHead>
              <StyledTableRow>
                {head.map((item, index) => (
                  <StyledTableCell key={index} sx={{ padding: '24px' }}>
                    {item}
                  </StyledTableCell>
                ))}
                <StyledTableCell />
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              {loading &&
                Array.from({ length: 10 })?.map((_, index) => (
                  <LoadingRow table={head} key={index} />
                ))}
              {!loading &&
                templates?.map(
                  (template) =>
                    template && (
                      <TemplateRow
                        key={template?._id}
                        template={template}
                        onView={() => {
                          setIsView(true);
                          setSelectedTemplate(template);
                        }}
                        onEdit={() => {
                          setIsEdit(true);
                          setSelectedTemplate(template);
                        }}
                        onDelete={() => {
                          setIsDelete(true);
                          setSelectedTemplate(template);
                        }}
                      />
                    )
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};
